module.exports = __webpack_public_path__ + "static/media/receive-detail-3.20cda381.jpg";